import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "mobile-betting-section" }
const _hoisted_2 = { class: "mobile-betting-header" }
const _hoisted_3 = { class: "mobile-section-title" }
const _hoisted_4 = { class: "mobile-tab-navigation" }
const _hoisted_5 = {
  key: 0,
  class: "mobile-tab-content active-tab-content"
}
const _hoisted_6 = { class: "mobile-market-dropdown-section" }
const _hoisted_7 = { class: "mobile-dropdown-container" }
const _hoisted_8 = { class: "mobile-dropdown-label" }
const _hoisted_9 = ["value"]
const _hoisted_10 = {
  key: 0,
  class: "mobile-number-selection-section"
}
const _hoisted_11 = { class: "mobile-number-selection-header" }
const _hoisted_12 = { class: "mobile-number-selection-title" }
const _hoisted_13 = {
  key: 0,
  class: "mobile-number-selection-odds"
}
const _hoisted_14 = {
  key: 0,
  class: "mobile-number-grid"
}
const _hoisted_15 = ["onClick"]
const _hoisted_16 = {
  key: 1,
  class: "mobile-number-grid"
}
const _hoisted_17 = ["onClick"]
const _hoisted_18 = {
  key: 2,
  class: "mobile-bonus-section mobile-color-combo-section"
}
const _hoisted_19 = {
  key: 3,
  class: "mobile-bonus-section"
}
const _hoisted_20 = { class: "mobile-bonus-title" }
const _hoisted_21 = {
  key: 0,
  class: "mobile-bonus-number-grid"
}
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { class: "mobile-market-info" }
const _hoisted_24 = { class: "mobile-market-text" }
const _hoisted_25 = {
  key: 0,
  class: "mobile-market-odds"
}
const _hoisted_26 = {
  key: 4,
  class: "mobile-betting-actions-primary"
}
const _hoisted_27 = ["disabled"]
const _hoisted_28 = { class: "mobile-betting-actions-secondary" }
const _hoisted_29 = {
  key: 1,
  class: "mobile-tab-content active-tab-content"
}
const _hoisted_30 = { class: "mobile-bonus-markets" }
const _hoisted_31 = { class: "mobile-bonus-group-title" }
const _hoisted_32 = { class: "mobile-bonus-markets-list" }
const _hoisted_33 = {
  key: 1,
  class: "mobile-bonus-market-item"
}
const _hoisted_34 = { class: "mobile-bonus-market-description" }
const _hoisted_35 = { class: "mobile-bonus-options" }
const _hoisted_36 = ["onClick"]
const _hoisted_37 = { class: "mobile-bonus-bet-content" }
const _hoisted_38 = { class: "mobile-bonus-bet-label" }
const _hoisted_39 = { class: "mobile-bonus-bet-odds" }

import { ref, computed, watch } from 'vue';
import { formatOdds } from '../../utils/currency';
import { getMarketDisplayLabel } from '../../utils/market';
import SameColorBallsSelector from '../SameColorBallsSelector.vue';
import BonusBallColorRow from '../BonusBallColorRow.vue';
import BettingPickActionButton from '../betting/BettingPickActionButton.vue';
import { getAvailablePickCounts, resolveDefaultPickCount, clampToAvailablePickCount } from '@/composables/useAvailablePickCounts';
import {
  isSameColorBallsMarket,
  formatSameColorBetText,
  buildSameColorMarketSelection,
  pickRandomBallColor,
  type BallColorSlug,
} from '@/constants/sameColorBalls';
import {
  isStandardBetPlusColorBonusMarket,
  buildStandardBetPlusColorBonusSelection,
  resolveColorBonusOutcome,
} from '@/constants/standardBetPlusColorBonus';
import { useIntegrationMode } from '@/composables/useIntegrationMode';


const __default__ = {
  name: "MobileBettingSection",
};

interface MarketOutcome {
  id: number;
  game_market_id?: number;
  text: string;
  select_numbers: boolean;
  pick: number;
  slug: string;
  odds: string;
  specifier: string | null;
}

interface Market {
  id: number;
  name: string;
  slug: string;
  description: string;
  ordering: number;
  outcomes: MarketOutcome[];
}

interface MarketGroup {
  id: number;
  name: string;
  slug: string;
  ordering: number;
  has_bonus: boolean;
  markets: Market[];
  rules: Array<{
    id: number;
    name: string;
    balls_min: number;
    balls_max: number;
    picks_min: number;
    picks_max: number;
    has_bonus: number | boolean;
    max_resulted: number;
    type: string;
  }>;
}

interface SelectedMarket {
  marketGroup: MarketGroup;
  market: Market;
  label: string;
  odds: number;
  select_numbers: boolean;
  balls: number;
  outcome_id: string;
  specifier?: string;
  game_market_id?: number;
}

interface Props {
  bettingMarkets: MarketGroup[];
  selectedMarket: SelectedMarket | null;
  hotNumbers?: number[];
  coldNumbers?: number[];
  betslipLength: number;
  streamlinedSelection?: boolean;
  enableHotColdNumbers?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    bettingMarkets: {},
    selectedMarket: {},
    hotNumbers: {},
    coldNumbers: {},
    betslipLength: {},
    streamlinedSelection: { type: Boolean },
    enableHotColdNumbers: { type: Boolean }
  },
  emits: ["select-market", "remove-market", "toggle-group", "tab-changed", "add-line", "remove-line", "add-to-betslip", "clear-all"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const { isLite } = useIntegrationMode();

const emit = __emit;

// Tab state
const activeTab = ref<'main' | 'bonus'>('main');

// Main market selection
const selectedMainMarket = ref<number | ''>('');
const selectedBonusMarkets = ref<Array<{ market: Market; outcome: MarketOutcome }>>([]);

// Number selection state
const selectedNumbers = ref<number[]>([]);
const selectedBonusNumbers = ref<number[]>([]);
const selectedBonusColor = ref<BallColorSlug | null>(null);
const lines = ref<Array<{ numbers: number[]; bonus?: number; numBets: number; picks: number; market?: SelectedMarket }>>([]);

// Quick pick pattern memory
const lastQuickPickPattern = ref<{ mainCount: number; bonusCount: number } | null>(null);

// Computed properties to separate markets
const mainMarkets = computed(() => {
  return props.bettingMarkets.filter(group => 
    group.markets.some(market => 
      market.outcomes.some(outcome => outcome.select_numbers) ||
      isStandardBetPlusColorBonusMarket(market.slug)
    )
  );
});

const bonusMarkets = computed(() => {
  return props.bettingMarkets.map(group => ({
    ...group,
    markets: group.markets.filter(market => 
      market.outcomes.every(outcome => !outcome.select_numbers) &&
      !isStandardBetPlusColorBonusMarket(market.slug)
    )
  })).filter(group => group.markets.length > 0);
});

// Flatten all main markets for dropdown
const allMainMarkets = computed(() => {
  const markets: Market[] = [];
  mainMarkets.value.forEach(group => {
    group.markets.forEach(market => {
      if (market.outcomes.some(outcome => outcome.select_numbers)) {
        markets.push(market);
      } else if (isStandardBetPlusColorBonusMarket(market.slug)) {
        markets.push(market);
      }
    });
  });
  return markets.sort((a, b) => {
    const isABonusBallSameDrum = a.slug === 'bonus-ball-bet-same-drum-as-standard-numbers';
    const isBBonusBallSameDrum = b.slug === 'bonus-ball-bet-same-drum-as-standard-numbers';
    if (isABonusBallSameDrum && !isBBonusBallSameDrum) return 1;
    if (!isABonusBallSameDrum && isBBonusBallSameDrum) return -1;
    return 0;
  });
});

// Get selected market data
const selectedMainMarketData = computed(() => {
  if (!selectedMainMarket.value) return null;
  return allMainMarkets.value.find(market => market.id === selectedMainMarket.value);
});

// Get market group for selected market
const selectedMainMarketGroup = computed(() => {
  if (!selectedMainMarket.value) return null;
  return mainMarkets.value.find(group => 
    group.markets.some(market => market.id === selectedMainMarket.value)
  );
});

// Color combo market (standard bet + bonus colour)
const isColorComboMarket = computed(() =>
  isStandardBetPlusColorBonusMarket(selectedMainMarketData.value?.slug ?? '')
);

const showMainNumberSelection = computed(() => {
  if (!selectedMainMarketData.value) return false;
  if (isColorComboMarket.value) return true;
  return selectedMainMarketData.value.outcomes.some((outcome) => outcome.select_numbers);
});

// Number selection computed properties
const actualBallsMax = computed(() => {
  if (selectedMainMarketGroup.value?.rules?.length) {
    const mainRule = selectedMainMarketGroup.value.rules.find(rule => rule.type === 'main' || !rule.has_bonus);
    return mainRule ? mainRule.balls_max : 49;
  }
  return 49; // Default
});

const actualBalls = computed(() => {
  if (isColorComboMarket.value) {
    const picks = selectedMainMarketData.value?.outcomes
      .map((o) => Number(o.pick) || 0)
      .filter((p) => p > 0) ?? [];
    return picks.length > 0 ? Math.min(...picks) : 1;
  }
  if (selectedMainMarketData.value?.outcomes) {
    const firstOutcome = selectedMainMarketData.value.outcomes.find(outcome => outcome.select_numbers);
    return firstOutcome ? firstOutcome.pick : 5;
  }
  return 5; // Default
});

const bonusBallsMax = computed(() => {
  if (isSameDrumMarket.value) {
    return actualBallsMax.value;
  }
  if (selectedMainMarketGroup.value?.rules?.length) {
    const bonusRule = selectedMainMarketGroup.value.rules.find(rule => rule.has_bonus === 1);
    return bonusRule ? bonusRule.balls_max : 20;
  }
  return 20; // Default
});

const maxSelectableBalls = computed(() => {
  if (selectedMainMarketData.value?.outcomes) {
    const picks = selectedMainMarketData.value.outcomes
      .map((outcome) => Number(outcome.pick) || 0)
      .filter((pick) => pick > 0);
    if (picks.length > 0) {
      return Math.max(...picks);
    }
    const maxPick = Math.max(...selectedMainMarketData.value.outcomes
      .filter(outcome => outcome.select_numbers)
      .map(outcome => outcome.pick)
    );
    return maxPick || actualBallsMax.value;
  }
  return actualBallsMax.value;
});

const comboMaxPick = computed(() => {
  if (!selectedMainMarketData.value) return 5;
  const picks = selectedMainMarketData.value.outcomes
    .map((o) => Number(o.pick) || 0)
    .filter((p) => p > 0);
  return picks.length > 0 ? Math.max(...picks) : 5;
});

const requiresBonusBall = computed(() => {
  return selectedMainMarketGroup.value?.has_bonus || false;
});

const isBonusOnlyMarket = computed(() => {
  const slug = selectedMainMarketGroup.value?.slug;
  return slug === 'bonus-ball-only-same-drum' || 
         slug === 'bonus-ball-only-additional-drum';
});

const availablePickCounts = computed(() =>
  getAvailablePickCounts(
    selectedMainMarketData.value,
    isBonusOnlyMarket.value,
    actualBalls.value
  )
);

const quickPickCount = ref(5);
const hotPickCount = ref(5);
const coldPickCount = ref(5);
const lastPickAction = ref<'quick' | 'hot' | 'cold' | null>(null);

const clearPickAction = () => {
  lastPickAction.value = null;
};

const syncPickCounts = () => {
  const defaultCount = resolveDefaultPickCount(availablePickCounts.value, actualBalls.value);
  quickPickCount.value = clampToAvailablePickCount(quickPickCount.value, availablePickCounts.value) || defaultCount;
  hotPickCount.value = clampToAvailablePickCount(hotPickCount.value, availablePickCounts.value) || defaultCount;
  coldPickCount.value = clampToAvailablePickCount(coldPickCount.value, availablePickCounts.value) || defaultCount;
};

watch([availablePickCounts, actualBalls], syncPickCounts, { immediate: true });

const isSameDrumMarket = computed(() => {
  const slug = selectedMainMarketGroup.value?.slug;
  return slug === 'standard-bet-and-bonus-ball-same-drum' ||
         slug === 'bonus-ball-only-same-drum' ||
         slug === 'standard-bet-bonus-from-same-drum' ||
         slug === 'regular-numbers-plus-bonus-ball-same-drum';
});

const isMainIncludingBonusMarket = computed(() => {
  const slug = selectedMainMarketGroup.value?.slug;
  return slug === 'standard-bet-bonus-from-same-drum';
});

const isSameDrumBonusMarket = computed(() => {
  const slug = selectedMainMarketGroup.value?.slug;
  return slug === 'bonus-ball-only-same-drum' ||
         slug === 'standard-bet-bonus-from-same-drum';
});

const hasAnySelection = computed(() => {
  return selectedNumbers.value.length > 0 || selectedBonusNumbers.value.length > 0;
});

const canAddLine = computed(() => {
  if (isColorComboMarket.value) {
    return selectedNumbers.value.length > 0 && selectedBonusColor.value !== null;
  }

  if (isBonusOnlyMarket.value) {
    return selectedBonusNumbers.value.length > 0 && Boolean(currentOutcome.value);
  }
  
  if (isMainIncludingBonusMarket.value) {
    return selectedNumbers.value.length >= 1 && Boolean(currentOutcome.value);
  }
  
  if (isSameDrumMarket.value && !isMainIncludingBonusMarket.value) {
    const hasDuplicates = selectedNumbers.value.some(mainNum => 
      selectedBonusNumbers.value.includes(mainNum)
    );
    if (hasDuplicates) {
      return false;
    }
    
    return selectedNumbers.value.length > 0 && selectedBonusNumbers.value.length > 0 && Boolean(currentOutcome.value);
  }
  
  if (requiresBonusBall.value && !isSameDrumMarket.value) {
    return selectedNumbers.value.length > 0 && selectedBonusNumbers.value.length > 0 && Boolean(currentOutcome.value);
  }
  return selectedNumbers.value.length > 0 && Boolean(currentOutcome.value);
});

// Computed properties for current odds display
const currentOutcome = computed(() => {
  if (isBonusOnlyMarket.value && selectedBonusNumbers.value.length > 0) {
    return selectedMainMarketData.value?.outcomes.find(outcome => 
      outcome.select_numbers && outcome.pick === selectedBonusNumbers.value.length
    );
  }

  if (!selectedMainMarketData.value || selectedNumbers.value.length === 0) return null;

  if (isColorComboMarket.value && selectedBonusColor.value) {
    return resolveColorBonusOutcome(
      selectedMainMarketData.value.outcomes,
      selectedBonusColor.value,
      selectedNumbers.value.length
    ) ?? null;
  }
  
  // For main including bonus markets, use the actual number count
  if (isMainIncludingBonusMarket.value) {
    return selectedMainMarketData.value.outcomes.find(outcome => 
      outcome.select_numbers && outcome.pick === selectedNumbers.value.length
    );
  }
  
  return selectedMainMarketData.value.outcomes.find(outcome => 
    outcome.select_numbers && outcome.pick === selectedNumbers.value.length
  );
});

const currentOdds = computed(() => {
  return currentOutcome.value ? Number(currentOutcome.value.odds) : null;
});

const hotNumbers = computed(() => props.hotNumbers || []);
const coldNumbers = computed(() => props.coldNumbers || []);
const shouldShowHotColdActions = computed(() => {
  return !isLite.value && props.enableHotColdNumbers === true && (hotNumbers.value.length > 0 || coldNumbers.value.length > 0);
});

const currentLineMarket = computed<SelectedMarket | undefined>(() => {
  if (selectedMainMarketData.value && selectedMainMarketGroup.value && currentOutcome.value) {
    if (isColorComboMarket.value && selectedBonusColor.value && selectedNumbers.value.length > 0) {
      const selection = buildStandardBetPlusColorBonusSelection(
        selectedNumbers.value,
        currentOutcome.value
      );
      return {
        marketGroup: selectedMainMarketGroup.value,
        market: selectedMainMarketData.value,
        label: selection.label,
        odds: selection.odds,
        select_numbers: true,
        balls: selection.picks,
        outcome_id: selection.outcome_id,
        game_market_id: selection.game_market_id,
      };
    }

    return {
      marketGroup: selectedMainMarketGroup.value,
      market: selectedMainMarketData.value,
      label: formatOutcomeText(currentOutcome.value),
      odds: Number(currentOutcome.value.odds),
      select_numbers: currentOutcome.value.select_numbers,
      balls: currentOutcome.value.pick,
      outcome_id: currentOutcome.value.id.toString()
    };
  }

  if (selectedMainMarketData.value && hasAnySelection.value) {
    return undefined;
  }

  return props.selectedMarket || undefined;
});


// Set default market selection
const formatOutcomeText = (outcome: MarketOutcome): string => {
  let text = outcome.text || outcome.id.toString();
  
  // Replace {value} placeholder with specifier value
  if (text.includes('{value}') && outcome.specifier) {
    text = text.replace('{value}', outcome.specifier);
  }
  
  return text;
};

const onMainMarketChange = () => {
  // Clear all number selections when market changes
  selectedNumbers.value = [];
  selectedBonusNumbers.value = [];
  selectedBonusColor.value = null;
  lines.value = [];
  
  if (selectedMainMarket.value && selectedMainMarketData.value && selectedMainMarketGroup.value) {
    if (isColorComboMarket.value) {
      return;
    }
    // Find the first outcome with select_numbers for this market
    const firstOutcome = selectedMainMarketData.value.outcomes.find(outcome => outcome.select_numbers);
    if (firstOutcome) {
      const marketData: SelectedMarket = {
        marketGroup: selectedMainMarketGroup.value,
        market: selectedMainMarketData.value,
        label: formatOutcomeText(firstOutcome),
        odds: Number(firstOutcome.odds),
        select_numbers: firstOutcome.select_numbers,
        balls: firstOutcome.pick,
        outcome_id: firstOutcome.id.toString()
      };
      emit('select-market', marketData);
    }
  }
};

const setDefaultMainMarket = () => {
  if (allMainMarkets.value.length > 0 && !selectedMainMarket.value) {
    selectedMainMarket.value = allMainMarkets.value[0].id;
    onMainMarketChange();
  }
};

// Watch for changes in allMainMarkets to set default when data is available
watch(allMainMarkets, (newMarkets) => {
  if (newMarkets.length > 0 && !selectedMainMarket.value) {
    setDefaultMainMarket();
  }
}, { immediate: true });

// Watch for tab changes to clear main market selection when switching to bonus
watch(activeTab, (newTab) => {
  emit('tab-changed', newTab);
  if (newTab === 'bonus') {
    selectedMainMarket.value = '';
  } else if (newTab === 'main' && !selectedMainMarket.value) {
    setDefaultMainMarket();
  }
});

// Initialize default selection
setDefaultMainMarket();

const selectSameColorBalls = (market: Market, outcome: MarketOutcome, group: MarketGroup) => {
  const label = formatSameColorBetText(outcome);
  const selection = buildSameColorMarketSelection(market, outcome);

  emit('select-market', {
    marketGroup: group,
    market: market,
    label: label,
    select_numbers: outcome.select_numbers,
    balls: outcome.pick,
    ...selection,
  });
};

const updateSelectedMarketForColorCombo = () => {
  if (!selectedMainMarketData.value || !selectedMainMarketGroup.value) return;
  if (!selectedBonusColor.value || selectedNumbers.value.length === 0) return;

  const outcome = resolveColorBonusOutcome(
    selectedMainMarketData.value.outcomes,
    selectedBonusColor.value,
    selectedNumbers.value.length
  );
  if (!outcome) return;

  const selection = buildStandardBetPlusColorBonusSelection(
    selectedNumbers.value,
    outcome
  );

  emit('select-market', {
    marketGroup: selectedMainMarketGroup.value,
    market: selectedMainMarketData.value,
    label: selection.label,
    odds: selection.odds,
    select_numbers: true,
    balls: selection.picks,
    outcome_id: selection.outcome_id,
    game_market_id: selection.game_market_id,
  });
};

const selectBonusMarket = (market: Market, outcome: MarketOutcome, group: MarketGroup) => {
  // Check if this market/outcome is already selected
  const isAlreadySelected = selectedBonusMarkets.value.some(selected => 
    selected.market.id === market.id &&
    selected.outcome.id === outcome.id
  );
  
  if (isAlreadySelected) {
    // Remove from selection (toggle off)
    selectedBonusMarkets.value = selectedBonusMarkets.value.filter(selected => 
      !(selected.market.id === market.id &&
        selected.outcome.id === outcome.id)
    );
    
    // Emit remove event to parent
    emit('remove-market', {
      marketGroup: group,
      market: market,
      label: formatOutcomeText(outcome),
      odds: Number(outcome.odds),
      select_numbers: outcome.select_numbers,
      balls: outcome.pick,
      outcome_id: outcome.id.toString()
    });
  } else {
    const siblingSelections = selectedBonusMarkets.value.filter(
      (selected) => selected.market.id === market.id && selected.outcome.id !== outcome.id
    );
    for (const sibling of siblingSelections) {
      emit('remove-market', {
        marketGroup: group,
        market: sibling.market,
        label: formatOutcomeText(sibling.outcome),
        odds: Number(sibling.outcome.odds),
        select_numbers: sibling.outcome.select_numbers,
        balls: sibling.outcome.pick,
        outcome_id: sibling.outcome.id.toString(),
      });
    }
    selectedBonusMarkets.value = selectedBonusMarkets.value.filter(
      (selected) => selected.market.id !== market.id
    );
    selectedBonusMarkets.value.push({ market, outcome });

    emit('select-market', {
      marketGroup: group,
      market: market,
      label: formatOutcomeText(outcome),
      odds: Number(outcome.odds),
      select_numbers: outcome.select_numbers,
      balls: outcome.pick,
      outcome_id: outcome.id.toString()
    });
  }
};

// Removed toggleBonusGroup - bonus markets are now always visible

const isMarketSelected = (market: Market, outcome: MarketOutcome): boolean => {
  // Check if this is a bonus market selection
  if (selectedBonusMarkets.value.length > 0) {
    return selectedBonusMarkets.value.some(selected => 
      selected.market.id === market.id &&
      selected.outcome.id === outcome.id
    );
  }
  
  // Check if this is a main market selection
  if (!props.selectedMarket) return false;
  return (
    props.selectedMarket.market.id === market.id &&
    props.selectedMarket.outcome_id === outcome.id.toString()
  );
};

const formatMarketDescription = (
  marketOrDescription: Market | string,
  specifier?: string | null
): string => {
  if (typeof marketOrDescription === 'string') {
    let description = marketOrDescription || '';
    if (!description) return '';

    if (description.includes('{value}') && specifier) {
      description = description.replace('{value}', specifier);
    }

    return description;
  }

  let description = marketOrDescription?.description || '';
  if (!description) return '';

  const outcomeWithSpecifier = marketOrDescription.outcomes.find(outcome => outcome.specifier);
  if (outcomeWithSpecifier?.specifier && description.includes('{value}')) {
    description = description.replace('{value}', outcomeWithSpecifier.specifier);
  }

  return description;
};


// Number selection methods
const toggleMainIncludingBonusNumber = (n: number) => {
  const index = selectedNumbers.value.indexOf(n);
  
  if (index === -1) {
    if (selectedNumbers.value.length < maxSelectableBalls.value) {
      selectedNumbers.value.push(n);
    }
  } else {
    // Remove number and shift remaining numbers
    selectedNumbers.value.splice(index, 1);
  }
  
  // Update market selection with current number count
  if (isColorComboMarket.value) {
    updateSelectedMarketForColorCombo();
  } else {
    updateSelectedMarketForBalls(selectedNumbers.value.length);
  }
};

const updateSelectedMarketForBalls = (numberOfBalls: number) => {
  if (!selectedMainMarketData.value || isColorComboMarket.value) return;
  
  // Find the outcome that matches the number of balls selected
  const matchingOutcome = selectedMainMarketData.value.outcomes.find(outcome => 
    outcome.select_numbers && outcome.pick === numberOfBalls
  );
  
  if (matchingOutcome && selectedMainMarketGroup.value) {
    const marketData: SelectedMarket = {
      marketGroup: selectedMainMarketGroup.value,
      market: selectedMainMarketData.value,
      label: formatOutcomeText(matchingOutcome),
      odds: Number(matchingOutcome.odds),
      select_numbers: matchingOutcome.select_numbers,
      balls: matchingOutcome.pick,
      outcome_id: matchingOutcome.id.toString()
    };
    emit('select-market', marketData);
  }
};

const toggleNumber = (n: number) => {
  clearPickAction();
  if (isSameDrumMarket.value && selectedBonusNumbers.value.includes(n)) {
    return;
  }
  
  if (selectedNumbers.value.includes(n)) {
    selectedNumbers.value = selectedNumbers.value.filter(num => num !== n);
  } else if (selectedNumbers.value.length < maxSelectableBalls.value) {
    selectedNumbers.value.push(n);
  }
  
  // Update market selection with current number count
  if (isColorComboMarket.value) {
    updateSelectedMarketForColorCombo();
  } else {
    updateSelectedMarketForBalls(selectedNumbers.value.length);
  }
};

const toggleBonusNumber = (n: number) => {
  clearPickAction();
  if (isSameDrumMarket.value && selectedNumbers.value.includes(n)) {
    return;
  }
  
  if (selectedBonusNumbers.value.includes(n)) {
    selectedBonusNumbers.value = selectedBonusNumbers.value.filter(num => num !== n);
  } else {
    selectedBonusNumbers.value = [n]; // Only one bonus number allowed
  }
};

const shuffleNumbers = (numbers: number[]) => [...numbers].sort(() => Math.random() - 0.5);

const fillSelectionFromPool = (
  preferredPool: number[],
  fallbackPool: number[],
  targetCount: number,
  excludedNumbers: number[] = []
) => {
  const excluded = new Set(excludedNumbers);
  const uniqueNumbers = new Set<number>();

  shuffleNumbers(preferredPool).forEach((num) => {
    if (!excluded.has(num) && uniqueNumbers.size < targetCount) {
      uniqueNumbers.add(num);
    }
  });

  if (uniqueNumbers.size < targetCount) {
    shuffleNumbers(fallbackPool).forEach((num) => {
      if (!excluded.has(num) && uniqueNumbers.size < targetCount) {
        uniqueNumbers.add(num);
      }
    });
  }

  return Array.from(uniqueNumbers).slice(0, targetCount);
};

const getTargetSelectionCounts = (mainCountOverride?: number) => {
  const clampMainCount = (count: number) => Math.min(Math.max(count, 0), maxSelectableBalls.value);

  if (isBonusOnlyMarket.value) {
    return {
      mainCount: 0,
      bonusCount: selectedBonusNumbers.value.length > 0 ? selectedBonusNumbers.value.length : 1,
    };
  }

  if (mainCountOverride != null) {
    return {
      mainCount: clampMainCount(clampToAvailablePickCount(mainCountOverride, availablePickCounts.value)),
      bonusCount: (requiresBonusBall.value || isSameDrumMarket.value) ? 1 : 0,
    };
  }

  if (selectedNumbers.value.length > 0 || selectedBonusNumbers.value.length > 0) {
    return {
      mainCount: clampMainCount(selectedNumbers.value.length > 0 ? selectedNumbers.value.length : actualBalls.value),
      bonusCount:
        selectedBonusNumbers.value.length > 0
          ? selectedBonusNumbers.value.length
          : (requiresBonusBall.value || isSameDrumMarket.value) ? 1 : 0,
    };
  }

  if (lastQuickPickPattern.value) {
    return {
      mainCount: clampMainCount(lastQuickPickPattern.value.mainCount),
      bonusCount: lastQuickPickPattern.value.bonusCount,
    };
  }

  return {
    mainCount: clampMainCount(actualBalls.value),
    bonusCount: (requiresBonusBall.value || isSameDrumMarket.value) ? 1 : 0,
  };
};

const applyTrendSelection = (preferredPool: number[], fallbackLabel: 'hot' | 'cold', mainCountOverride?: number) => {
  const { mainCount, bonusCount } = getTargetSelectionCounts(mainCountOverride);

  selectedNumbers.value = [];
  selectedBonusNumbers.value = [];

  if (isBonusOnlyMarket.value) {
    const bonusPool = preferredPool.filter((n) => n <= bonusBallsMax.value);
    selectedBonusNumbers.value = fillSelectionFromPool(
      bonusPool,
      Array.from({ length: bonusBallsMax.value }, (_, i) => i + 1),
      bonusCount
    );
    lastQuickPickPattern.value = { mainCount, bonusCount };
    return;
  }

  if (mainCount > 0) {
    const preferredMainPool = preferredPool.filter((n) => n <= actualBallsMax.value);
    selectedNumbers.value = fillSelectionFromPool(
      preferredMainPool,
      Array.from({ length: actualBallsMax.value }, (_, i) => i + 1),
      mainCount
    );
  }

  if (bonusCount > 0) {
    const preferredBonusPool = preferredPool.filter((n) => n <= bonusBallsMax.value);
    const availableBonusPool = Array.from({ length: bonusBallsMax.value }, (_, i) => i + 1);
    selectedBonusNumbers.value = fillSelectionFromPool(
      preferredBonusPool,
      availableBonusPool,
      bonusCount,
      isSameDrumMarket.value ? selectedNumbers.value : []
    );
  }

  lastQuickPickPattern.value = { mainCount, bonusCount };
  updateSelectedMarketForBalls(selectedNumbers.value.length);

  if ((mainCount > 0 && selectedNumbers.value.length < mainCount) || (bonusCount > 0 && selectedBonusNumbers.value.length < bonusCount)) {
    console.warn(`Unable to fully apply ${fallbackLabel} number selection pattern; used best available fallback numbers.`);
  }
};

const quickPick = (mainCountOverride?: number) => {
  lastPickAction.value = 'quick';
  if (isBonusOnlyMarket.value) {
    // For bonus-only markets, maintain the same number of bonus selections
    const currentBonusCount = selectedBonusNumbers.value.length;
    const targetBonusCount = currentBonusCount > 0 ? currentBonusCount : 1;
    
    const bonusNumbers = Array.from({ length: bonusBallsMax.value }, (_, i) => i + 1);
    const shuffledBonus = bonusNumbers.sort(() => Math.random() - 0.5);
    selectedBonusNumbers.value = shuffledBonus.slice(0, targetBonusCount);
    
    // Store pattern for bonus-only market
    lastQuickPickPattern.value = { mainCount: 0, bonusCount: targetBonusCount };
  } else {
    // For regular markets, 
    let mainCount: number;
    let bonusCount: number;
    
    // If user has existing selections, maintain the same count but clear previous selections
    if (mainCountOverride != null) {
      mainCount = clampToAvailablePickCount(mainCountOverride, availablePickCounts.value);
      bonusCount = (requiresBonusBall.value || isSameDrumMarket.value) ? 1 : 0;
      selectedNumbers.value = [];
      selectedBonusNumbers.value = [];
    } else if (selectedNumbers.value.length > 0 || selectedBonusNumbers.value.length > 0) {
      mainCount = Math.min(selectedNumbers.value.length > 0 ? selectedNumbers.value.length : actualBalls.value, maxSelectableBalls.value);
      bonusCount = selectedBonusNumbers.value.length > 0 ? selectedBonusNumbers.value.length : 
                   ((requiresBonusBall.value || isSameDrumMarket.value) ? 1 : 0);
      
      // Clear previous selections before picking new ones
      selectedNumbers.value = [];
      selectedBonusNumbers.value = [];
    } else if (lastQuickPickPattern.value) {
      // Use the same pattern as the last quick pick
      mainCount = Math.min(lastQuickPickPattern.value.mainCount, maxSelectableBalls.value);
      bonusCount = lastQuickPickPattern.value.bonusCount;
    } else {
      // First time - use current market requirements
      mainCount = Math.min(actualBalls.value, maxSelectableBalls.value);
      bonusCount = (requiresBonusBall.value || isSameDrumMarket.value) ? 1 : 0;
    }
    
    // Quick pick main numbers
    if (mainCount > 0) {
      const availableNumbers = Array.from({ length: actualBallsMax.value }, (_, i) => i + 1);
      const shuffled = availableNumbers.sort(() => Math.random() - 0.5);
      selectedNumbers.value = shuffled.slice(0, mainCount);
    }
    
    // Quick pick bonus numbers (if required)
    if (bonusCount > 0) {
      const bonusNumbers = Array.from({ length: bonusBallsMax.value }, (_, i) => i + 1);
      const availableBonusNumbers = isSameDrumMarket.value 
        ? bonusNumbers.filter(num => !selectedNumbers.value.includes(num))
        : bonusNumbers;
      
      if (availableBonusNumbers.length > 0) {
        const shuffledBonus = availableBonusNumbers.sort(() => Math.random() - 0.5);
        selectedBonusNumbers.value = shuffledBonus.slice(0, bonusCount);
      } else {
        selectedBonusNumbers.value = [];
      }
    }
    
    // Store the pattern for next quick pick
    lastQuickPickPattern.value = { mainCount, bonusCount };

    if (isColorComboMarket.value) {
      selectedBonusColor.value = pickRandomBallColor();
    }
    
    // Update market selection to match the number of balls selected
    if (isColorComboMarket.value) {
      updateSelectedMarketForColorCombo();
    } else {
      updateSelectedMarketForBalls(selectedNumbers.value.length);
    }
  }

};

const buildCurrentLine = () => ({
  numbers: [...selectedNumbers.value],
  bonus: (requiresBonusBall.value || (isSameDrumMarket.value && !isMainIncludingBonusMarket.value) || isBonusOnlyMarket.value) ? selectedBonusNumbers.value[0] : undefined,
  bonusColor: isColorComboMarket.value ? selectedBonusColor.value ?? undefined : undefined,
  numBets: 1,
  picks: selectedNumbers.value.length,
  market: currentLineMarket.value
});

const finalizeLine = (line = buildCurrentLine()) => {
  lastQuickPickPattern.value = {
    mainCount: selectedNumbers.value.length,
    bonusCount: selectedBonusNumbers.value.length
  };

  if (props.streamlinedSelection) {
    emit('add-to-betslip', [line]);
  } else {
    lines.value.push(line);
    emit('add-line', line);
  }

  selectedNumbers.value = [];
  selectedBonusNumbers.value = [];
  selectedBonusColor.value = null;
};

const addLine = () => {
  if (!canAddLine.value) return;
  finalizeLine();
};

const selectHotNumbers = (mainCountOverride?: number) => {
  const pool = [...hotNumbers.value];
  if (!pool.length) return;
  lastPickAction.value = 'hot';
  applyTrendSelection(pool, 'hot', mainCountOverride);

};

const selectColdNumbers = (mainCountOverride?: number) => {
  const pool = [...coldNumbers.value];
  if (!pool.length) return;
  lastPickAction.value = 'cold';
  applyTrendSelection(pool, 'cold', mainCountOverride);

};

const bonusColorMap: Record<string, string> = {
  blue: '#3B82F6',
  brown: '#8B5E3C',
  green: '#28AA23',
  orange: '#F28C28',
  purple: '#7C3AED',
  red: '#E53935',
  yellow: '#EAB308',
};

const getBonusColorKey = (outcome: MarketOutcome) => {
  const normalized = outcome.text.trim().toLowerCase();
  return Object.keys(bonusColorMap).find((key) => normalized.startsWith(key)) || '';
};

const getBonusColorClass = (outcome: MarketOutcome) => {
  return getBonusColorKey(outcome) ? 'bonus-color-option' : '';
};

const getBonusColorStyle = (outcome: MarketOutcome) => {
  const key = getBonusColorKey(outcome);
  return key ? { '--bonus-color-swatch': bonusColorMap[key] } : {};
};

watch(selectedBonusColor, () => {
  if (isColorComboMarket.value) {
    updateSelectedMarketForColorCombo();
  }
});

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const removeLine = (index: number) => {
  lines.value.splice(index, 1);
  emit('remove-line', index);
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const clearAll = () => {
  lines.value = [];
  selectedNumbers.value = [];
  selectedBonusNumbers.value = [];
  emit('clear-all');
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const addToBetslip = () => {
  emit('add-to-betslip', lines.value);
};

// Reset quick pick pattern when market changes
watch(selectedMainMarket, () => {
  lastQuickPickPattern.value = null;
});

watch(() => props.betslipLength, (newLength, oldLength) => {
  if (oldLength && oldLength > 0 && newLength === 0) {
    selectedBonusMarkets.value = [];
  }
});

// Reset internal state when market is cleared
watch(() => props.selectedMarket, (newMarket) => {
  if (!newMarket) {
    // Reset all internal state when market is cleared
    selectedNumbers.value = [];
    selectedBonusNumbers.value = [];
    lines.value = [];
    lastQuickPickPattern.value = null;
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.$t('betting.selectYourMarket')), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("button", {
        class: _normalizeClass(["mobile-tab-btn", { active: activeTab.value === 'main' }]),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (activeTab.value = 'main'))
      }, " 🎯 " + _toDisplayString(_ctx.$t('betting.mainMarkets')), 3),
      _createElementVNode("button", {
        class: _normalizeClass(["mobile-tab-btn", { active: activeTab.value === 'bonus' }]),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (activeTab.value = 'bonus'))
      }, " 🎁 " + _toDisplayString(_ctx.$t('betting.bonusMarkets')), 3)
    ]),
    (activeTab.value === 'main')
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.$t('betting.selectMarket')) + ":", 1),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selectedMainMarket).value = $event)),
                class: "mobile-market-dropdown",
                onChange: onMainMarketChange
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allMainMarkets.value, (market) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: market.id,
                    value: market.id
                  }, _toDisplayString(_unref(getMarketDisplayLabel)(market)), 9, _hoisted_9))
                }), 128))
              ], 544), [
                [_vModelSelect, selectedMainMarket.value]
              ])
            ])
          ]),
          (selectedMainMarketData.value && showMainNumberSelection.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t('betting.selectNumbers')), 1),
                  (currentOdds.value && selectedNumbers.value.length > 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.$t('betting.odds')) + ": " + _toDisplayString(_unref(formatOdds)(currentOdds.value)), 1))
                    : _createCommentVNode("", true)
                ]),
                (!isBonusOnlyMarket.value && !isMainIncludingBonusMarket.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(actualBallsMax.value, (n) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: n,
                          class: _normalizeClass(["mobile-number-circle", {
              selected: selectedNumbers.value.includes(n),
              hot: hotNumbers.value?.includes(n),
              cold: coldNumbers.value?.includes(n),
              disabled: (isSameDrumMarket.value) && selectedBonusNumbers.value.includes(n),
              'quick-pick': selectedNumbers.value.includes(n) && selectedNumbers.value.length === actualBalls.value,
            }]),
                          onClick: ($event: any) => (toggleNumber(n))
                        }, _toDisplayString(n), 11, _hoisted_15))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                (isMainIncludingBonusMarket.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(actualBallsMax.value, (n) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: n,
                          class: _normalizeClass(["mobile-number-circle", {
              selected: selectedNumbers.value.includes(n),
              hot: hotNumbers.value?.includes(n),
              cold: coldNumbers.value?.includes(n),
              'quick-pick': selectedNumbers.value.includes(n) && selectedNumbers.value.length >= 1,
            }]),
                          onClick: ($event: any) => (toggleMainIncludingBonusNumber(n))
                        }, _toDisplayString(n), 11, _hoisted_17))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                (isColorComboMarket.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                      _createVNode(BonusBallColorRow, {
                        modelValue: selectedBonusColor.value,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((selectedBonusColor).value = $event))
                      }, null, 8, ["modelValue"])
                    ]))
                  : _createCommentVNode("", true),
                ((requiresBonusBall.value || isSameDrumMarket.value || isBonusOnlyMarket.value) && !isMainIncludingBonusMarket.value && !isColorComboMarket.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                      _createElementVNode("div", _hoisted_20, _toDisplayString(isSameDrumBonusMarket.value ? '' : (isBonusOnlyMarket.value ? _ctx.$t('betting.selectBonusNumber') : _ctx.$t('betting.bonusNumber'))), 1),
                      (!isSameDrumBonusMarket.value || isBonusOnlyMarket.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bonusBallsMax.value, (n) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: `bonus-${n}`,
                                class: _normalizeClass(["mobile-number-circle mobile-bonus-circle", {
                selected: selectedBonusNumbers.value.includes(n),
                hot: hotNumbers.value?.includes(n),
                cold: coldNumbers.value?.includes(n),
                disabled: (isSameDrumMarket.value) && selectedNumbers.value.includes(n),
              }]),
                                onClick: ($event: any) => (toggleBonusNumber(n))
                              }, _toDisplayString(n), 11, _hoisted_22))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["mobile-market-display", { 'center-layout': !((isBonusOnlyMarket.value && selectedBonusNumbers.value.length > 0) || (!isBonusOnlyMarket.value && selectedNumbers.value.length > 0)) }])
                  }, [
                    _createElementVNode("span", _hoisted_24, [
                      (isMainIncludingBonusMarket.value)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            (selectedNumbers.value.length === 0)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createTextVNode(_toDisplayString(_ctx.$t('betting.pleaseSelectNumbers')), 1)
                                ], 64))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createTextVNode(_toDisplayString(_ctx.$t('betting.selectedBalls', { count: selectedNumbers.value.length })), 1)
                                ], 64))
                          ], 64))
                        : ((isBonusOnlyMarket.value && selectedBonusNumbers.value.length > 0) || (!isBonusOnlyMarket.value && selectedNumbers.value.length > 0))
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createTextVNode(_toDisplayString(isBonusOnlyMarket.value 
                  ? _ctx.$t('betting.selectedBonusBalls', { count: selectedBonusNumbers.value.length })
                  : _ctx.$t('betting.selectedBalls', { count: selectedNumbers.value.length })), 1)
                            ], 64))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                              _createTextVNode(_toDisplayString(_ctx.$t('betting.pleaseSelectNumber')), 1)
                            ], 64))
                    ]),
                    (selectedNumbers.value.length > 0 || (isColorComboMarket.value && selectedBonusColor.value))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(_unref(formatOdds)(currentOdds.value)), 1))
                      : _createCommentVNode("", true)
                  ], 2)
                ]),
                (hasAnySelection.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "mobile-betting-action-btn-hero",
                        disabled: !canAddLine.value,
                        onClick: addLine
                      }, _toDisplayString(props.streamlinedSelection ? _ctx.$t('detail.addToBetslip') : _ctx.$t('betting.addLine')), 9, _hoisted_27)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_28, [
                  _createVNode(BettingPickActionButton, {
                    variant: "quick",
                    platform: "mobile",
                    "pick-options": availablePickCounts.value,
                    "selected-count": quickPickCount.value,
                    active: lastPickAction.value === 'quick' && hasAnySelection.value,
                    "onUpdate:selectedCount": _cache[4] || (_cache[4] = ($event: any) => (quickPickCount.value = $event)),
                    onAction: quickPick
                  }, {
                    icon: _withCtx(() => _cache[7] || (_cache[7] = [
                      _createElementVNode("svg", {
                        viewBox: "0 0 24 24",
                        fill: "none",
                        stroke: "currentColor",
                        "stroke-width": "2.1",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                      }, [
                        _createElementVNode("path", { d: "M16 3h5v5" }),
                        _createElementVNode("path", { d: "m8 16-5 5" }),
                        _createElementVNode("path", { d: "M21 3l-7 7" }),
                        _createElementVNode("path", { d: "M3 8V3h5" }),
                        _createElementVNode("path", { d: "m3 3 7 7" }),
                        _createElementVNode("path", { d: "m14 14 7 7" })
                      ], -1)
                    ])),
                    default: _withCtx(() => [
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('betting.quickPick')), 1)
                    ]),
                    _: 1
                  }, 8, ["pick-options", "selected-count", "active"]),
                  (shouldShowHotColdActions.value)
                    ? (_openBlock(), _createBlock(BettingPickActionButton, {
                        key: 0,
                        variant: "hot",
                        platform: "mobile",
                        "pick-options": availablePickCounts.value,
                        "selected-count": hotPickCount.value,
                        active: lastPickAction.value === 'hot' && hasAnySelection.value,
                        "onUpdate:selectedCount": _cache[5] || (_cache[5] = ($event: any) => (hotPickCount.value = $event)),
                        onAction: selectHotNumbers
                      }, {
                        icon: _withCtx(() => _cache[8] || (_cache[8] = [
                          _createElementVNode("svg", {
                            viewBox: "0 0 24 24",
                            fill: "currentColor"
                          }, [
                            _createElementVNode("path", { d: "M12.7 2.6c.3 2-.3 3.5-1.7 5.2-1 1.2-1.6 2.2-1.6 3.7 0 1.8 1.3 3.1 3 3.1 2.3 0 3.8-1.9 3.8-4.3 0-1.1-.3-2.1-1.1-3.5 2.9 1.6 4.8 4.4 4.8 7.8 0 4.2-3.2 7.4-7.7 7.4-4.1 0-7.2-2.9-7.2-6.9 0-2.8 1.4-4.9 3.6-6.9 1.8-1.7 3-3.1 4.1-5.6z" })
                          ], -1)
                        ])),
                        default: _withCtx(() => [
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('betting.hotNumbers')), 1)
                        ]),
                        _: 1
                      }, 8, ["pick-options", "selected-count", "active"]))
                    : _createCommentVNode("", true),
                  (shouldShowHotColdActions.value)
                    ? (_openBlock(), _createBlock(BettingPickActionButton, {
                        key: 1,
                        variant: "cold",
                        platform: "mobile",
                        "pick-options": availablePickCounts.value,
                        "selected-count": coldPickCount.value,
                        active: lastPickAction.value === 'cold' && hasAnySelection.value,
                        "onUpdate:selectedCount": _cache[6] || (_cache[6] = ($event: any) => (coldPickCount.value = $event)),
                        onAction: selectColdNumbers
                      }, {
                        icon: _withCtx(() => _cache[9] || (_cache[9] = [
                          _createElementVNode("svg", {
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            "stroke-width": "1.9",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round"
                          }, [
                            _createElementVNode("path", { d: "M12 2v20" }),
                            _createElementVNode("path", { d: "m4.9 6.1 14.2 11.8" }),
                            _createElementVNode("path", { d: "m19.1 6.1-14.2 11.8" }),
                            _createElementVNode("path", { d: "M4 12h16" })
                          ], -1)
                        ])),
                        default: _withCtx(() => [
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('betting.coldNumbers')), 1)
                        ]),
                        _: 1
                      }, 8, ["pick-options", "selected-count", "active"]))
                    : _createCommentVNode("", true),
                  _createElementVNode("button", {
                    type: "button",
                    class: "mobile-betting-action-btn-secondary mobile-betting-action-btn-secondary--clear",
                    onClick: clearAll
                  }, [
                    _cache[10] || (_cache[10] = _createStaticVNode("<span class=\"betting-action-btn-icon\" aria-hidden=\"true\" data-v-34d3e8b4><svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-34d3e8b4><path d=\"M3 6h18\" data-v-34d3e8b4></path><path d=\"M8 6V4h8v2\" data-v-34d3e8b4></path><path d=\"m19 6-1 14H6L5 6\" data-v-34d3e8b4></path></svg></span>", 1)),
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('common.clearAll')), 1)
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (activeTab.value === 'bonus')
      ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
          _createElementVNode("div", _hoisted_30, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bonusMarkets.value, (group) => {
              return (_openBlock(), _createElementBlock("div", {
                key: group.id,
                class: "mobile-bonus-group"
              }, [
                _createElementVNode("div", _hoisted_31, _toDisplayString(group.markets[0] ? _unref(getMarketDisplayLabel)(group.markets[0]) : group.name), 1),
                _createElementVNode("div", _hoisted_32, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.markets, (market) => {
                    return (_openBlock(), _createElementBlock(_Fragment, {
                      key: market.id
                    }, [
                      (_unref(isSameColorBallsMarket)(market.slug))
                        ? (_openBlock(), _createBlock(SameColorBallsSelector, {
                            key: 0,
                            market: market,
                            class: "mobile-same-color-selector",
                            onSelect: (outcome) => selectSameColorBalls(market, outcome, group)
                          }, null, 8, ["market", "onSelect"]))
                        : (market.outcomes && market.outcomes.length > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                              _createElementVNode("div", _hoisted_34, _toDisplayString(formatMarketDescription(market)), 1),
                              _createElementVNode("div", _hoisted_35, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(market.outcomes, (outcome) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: outcome.id,
                                    class: _normalizeClass(["mobile-bonus-bet-card", [
                      { selected: isMarketSelected(market, outcome) },
                      getBonusColorClass(outcome)
                    ]]),
                                    style: _normalizeStyle(getBonusColorStyle(outcome)),
                                    onClick: ($event: any) => (selectBonusMarket(market, outcome, group))
                                  }, [
                                    _createElementVNode("div", _hoisted_37, [
                                      _createElementVNode("div", _hoisted_38, _toDisplayString(formatOutcomeText(outcome)), 1),
                                      _createElementVNode("div", _hoisted_39, _toDisplayString(_unref(formatOdds)(Number(outcome.odds))), 1)
                                    ]),
                                    _cache[11] || (_cache[11] = _createElementVNode("div", { class: "mobile-bonus-bet-indicator" }, [
                                      _createElementVNode("div", { class: "mobile-bonus-bet-check" }, " ✓ ")
                                    ], -1))
                                  ], 14, _hoisted_36))
                                }), 128))
                              ])
                            ]))
                          : _createCommentVNode("", true)
                    ], 64))
                  }), 128))
                ])
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})